// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6967db34] .el-dialog--center .el-dialog__body {\n  padding: 10px 32px 0;\n}\n.fix-form .label-title[data-v-6967db34] {\n  font-weight: bold;\n  font-size: 14px;\n  color: #2F3030;\n  margin-bottom: 2px;\n}\n.fix-form[data-v-6967db34] .check-group {\n  margin-bottom: 20px;\n}\n.fix-form[data-v-6967db34] .el-checkbox {\n  display: block;\n  line-height: 34px;\n}\n.fix-form[data-v-6967db34] .el-checkbox .name-text {\n  color: #606266;\n}", ""]);
// Exports
module.exports = exports;
